import {MAIN_BOARD_WEEK_ALL, MAIN_BOARD_DATE_SCOPE_ALL, MAIN_BOARD_AMOUNT_SCOPE_ALL, MAIN_BOARD_NUM_COUNT, AGENT_ACC_INFO} from "../utils/cons";
import {getRequest} from "../utils/api";

export function getPayAmountWeek () {
    return new Promise((resolve, reject) => {

        getRequest(MAIN_BOARD_WEEK_ALL).then(resp => {
            if (resp && resp.obj) {
                console.log("MAIN_BOARD_WEEK_ALL", resp)
                resp.obj.yesterdayAmt = Number(resp.obj.yesterdayAmt).toFixed(2)
                resp.obj.todayAmt = Number(resp.obj.todayAmt).toFixed(2)
                resp.obj.last7DayAmt = Number(resp.obj.last7DayAmt).toFixed(2)
                resolve(resp.obj)
            } else {
                resolve({})
            }
        });

        /**
        setTimeout(() => {
            resolve({"dataArray":[8200.01,11400.00,11800.00,12000.00,35000.00,20000.00,10000.00],"yesterdayAmount":"5125156.00","todayPayCount":"328","todayAmount":"3151156.00","payWeek":8200.01})
        }, 500)
        */
    })
}

export function getNumCount () {
    return new Promise((resolve, reject) => {
        getRequest(MAIN_BOARD_NUM_COUNT).then(resp => {
            if (resp && resp.obj) {
                console.log("MAIN_BOARD_NUM_COUNT", resp)
                resp.obj.totalAmount = Number(resp.obj.totalAmount).toFixed(2)
                resp.obj.accRewardAmt = Number(resp.obj.accRewardAmt).toFixed(2)
                resp.obj.accSettleAmt = Number(resp.obj.accSettleAmt).toFixed(2)
                resp.obj.accBalanceAmt = Number(resp.obj.accBalanceAmt).toFixed(2)
                resolve(resp.obj)
            } else {
                resolve({})
            }
        });


        /**
        setTimeout(() => {
            resolve({"totalAmount":15156.71,"totalMch":434,"totalCount":61,"totalIsv":64})
        }, 500)
        */
    })
}

export function getPayCount (parameter) {
    console.log("getPayCount", JSON.stringify(parameter))

    let param = ""
    if (parameter.createdStart && parameter.createdEnd) {
        param = "?dateScope=" + [parameter.createdStart, parameter.createdEnd]
    }
    return new Promise((resolve, reject) => {
        getRequest(MAIN_BOARD_DATE_SCOPE_ALL + param).then(resp => {
            if (resp && resp.obj) {
                console.log("ENT_C_MAIN_PAY_COUNT", resp)
                let data = []
                resp.obj.dataTotalGroups.forEach(item => {
                    data.push({
                        title: item.title.substring(5,10),
                        cnt: item.cnt,
                        amt: item.amt
                    })
                })
                resolve(data)
            } else {
                resolve([])
            }
        });

        /**
        setTimeout(() => {
            resolve([{"date":"09-22","type":"收款","payAmount":15156.71},{"date":"09-23","type":"收款","payAmount":25156},{"date":"09-24","type":"收款","payAmount":51156},{"date":"09-25","type":"收款","payAmount":75156},{"date":"09-26","type":"收款","payAmount":35156},{"date":"09-27","type":"收款","payAmount":65156},{"date":"09-28","type":"收款","payAmount":45156},{"date":"09-22","type":"退款","payAmount":2400.01},{"date":"09-23","type":"退款","payAmount":0},{"date":"09-24","type":"退款","payAmount":0},{"date":"09-25","type":"退款","payAmount":11400},{"date":"09-26","type":"退款","payAmount":0},{"date":"09-27","type":"退款","payAmount":7700},{"date":"09-28","type":"退款","payAmount":0}])
        }, 500)
        */
    })
}

export function getPayType (parameter) {
    console.log("getPayType", JSON.stringify(parameter))

    let param = ""
    if (parameter.createdStart && parameter.createdEnd) {
        param = "?dateScope=" + [parameter.createdStart, parameter.createdEnd]
    }
    return new Promise((resolve, reject) => {
        getRequest(MAIN_BOARD_AMOUNT_SCOPE_ALL + param).then(resp => {
            if (resp && resp.obj) {
                console.log("ENT_C_MAIN_PAY_TYPE_COUNT", resp)
                let data = []
                resp.obj.forEach(item => {
                    data.push({
                        typeName: item.alias, // item.title,
                        typeCount: item.cnt,
                        typeAmount: item.amt
                    })
                })
                resolve([data])
            } else {
                resolve([[]])
            }
        });

        /**
        setTimeout(() => {
            // resolve([[{"wayCode":"WX_QR","typeName":"微信扫码","typeAmount":269470.01,"typeCount":2}, {"wayCode":"ALI_QR","typeName":"支付宝扫码","typeAmount":138682.19,"typeCount":2}, {"wayCode":"BANK","typeName":"银行卡","typeAmount":48665.00,"typeCount":2}, {"wayCode":"UNION_PAY","typeName":"银联云闪付","typeAmount":39808.50,"typeCount":2}]])
        }, 500)
         */
    })
}

export function getTaskRate () {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve({"taskRate": 0.25})
        }, 500)
    })
}


export function getAgentAccInfo (id) {
    return new Promise((resolve, reject) => {
        getRequest(AGENT_ACC_INFO + "?id=" + id).then(resp => {
            if (resp && resp.obj) {
                console.log("AGENT_ACC_INFO", resp)
                resolve(resp.obj)
            } else {
                resolve({})
            }
        });
    })
}
